import { AsyncStoreItem } from '@lib/store';
import { ReservationAvailabilityResponse } from 'src/sdk-member';

/**
 * ReservationAvailability model
 */
export interface ReservationAvailabilityModel {
  model: ReservationAvailabilityResponse | null;
}

/**
 * ReservationAvailabilityResponse model details
 */
export interface ReservationAvailabilityStateDetails extends AsyncStoreItem {}

/**
 * ReservationAvailability store state
 */
export interface ReservationAvailabilityState
  extends ReservationAvailabilityStateDetails,
    ReservationAvailabilityModel {}

/**
 * Name of the ReservationAvailability Store
 */
export const RESERVATION_AVAILABILITY_STORE_NAME = 'reservationAvailability';

/**
 * ReservationAvailability Store Interface
 */
export interface ReservationAvailabilityStore {
  /** ReservationAvailability state */
  [RESERVATION_AVAILABILITY_STORE_NAME]: ReservationAvailabilityState;
}
